import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateFormsState from './workspaceForms';
import updateLocationsState from './workspaceLocations';
import updateRequestsState from './requests';

const handlers = {
  ...updateFormsState,
  ...updateLocationsState,
  ...updateRequestsState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
